import { apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Authentication Service
 * Handles login and profile updates
 */
const AuthService = {
  /**
   * Admin login with automatic token storage
   * @param {Object} loginData - Login credentials
   * @returns {Promise} API response
   */
  async login(loginData) {
    const response = await apiPost(API_ENDPOINTS.AUTH.LOGIN, loginData);
    const data = response.data.data;

    if (data) {
      const carMeetStorage = {
        token: data?.token,
        email: data?.user?.email,
        isLoggedIn: true,
        name: data?.user?.name,
        firstname: data?.user?.firstname,
        lastname: data?.user?.lastname,
        profilepic: data?.user?.profilepic,
        username: data?.user?.username,
        _id: data?.user?._id,
      };
      localStorage.setItem("car-meet-storage", JSON.stringify(carMeetStorage));
    }
    return response;
  },

  /**
   * Update user profile
   * @param {Object} profileData - Profile update data
   * @returns {Promise} API response
   */
  async updateProfile(profileData) {
    return apiPost(API_ENDPOINTS.AUTH.UPDATE_PROFILE, profileData);
  },
};

export default AuthService;
